import { useTimeTracking } from "@certn/utils";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { useEffectOnce } from "usehooks-ts";

export function useQuickscreenPageLogic() {
  const { caseId } = useParams();

  const starting = useRef(false);
  const [started, setStarted] = useState(false);
  const { startTimeTracker, cancelTimeTracker } = useTimeTracking();

  useEffect(() => {
    startTimeTracker("application--submit");

    return () => {
      cancelTimeTracker("application--submit");
    };
  }, [startTimeTracker, cancelTimeTracker]);

  function startApplication(caseId: string) {
    if (starting.current) {
      return;
    }

    starting.current = true;
    setStarted(true);
  }

  useEffectOnce(() => {
    caseId && startApplication(caseId);
  });

  return {
    started,
  };
}
